<a href="#" (click)="onClick($event)" class="mu-link">
  {{ muName }}
</a> 